import React, { Fragment, useEffect, useState, useCallback } from "react";
import { Menu, Popover, Transition } from "@headlessui/react";
import { HiOutlineBell, HiOutlineUser } from "react-icons/hi";
import { BsCart4 } from "react-icons/bs";
import { TiCalculator } from "react-icons/ti";
import "../calculator.css";
import { useNavigate, useParams } from "react-router-dom";
import classNames from "classnames";
import { useDispatch, useSelector } from "react-redux";
import { getUser } from "../../services/auth.service";
import { setUser } from "../../store/reducers/userReducer";
import { getBussinessData } from "../../store/actions/action";
import {
  getNotifications,
  markAllNotificationsAsRead,
} from "../../services/notification.service";
import Notification from "./notification";
import Calculator from "../calculator";
import UserImage from "../common/user-image/UserImage";
import { useTranslation } from "react-i18next";
import LanguageChenger from "../LanguageChenger";
import { getOneEmployee } from "../../services/employee.service";
import ThemeBtn from "../themebtn";
import Joyride from "react-joyride";
import { io } from "socket.io-client";
import {
  FiUser as UserIcon,
  FiPlusCircle as PlusCircleIcon,
  FiGrid as GridIcon,
  FiLogOut as LogoutIcon,
} from "react-icons/fi";
import { AWS_URL, CHAT_URL } from "../../services/http.service";
import { IoSettingsOutline } from "react-icons/io5";
import PaymentGatewayPopup from "../paymentpopup";
import BusinessDetailsQrPopup from "../BusinessDetailsQrPopup";
import { MdOutlineSubscriptions } from "react-icons/md";
import { MdFingerprint } from "react-icons/md";
import { startRegistration } from "@simplewebauthn/browser";
import { passkeyService } from "../../services/passkey.service";
import { toast } from "react-toastify";
export default function Header() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { bussinessUuid } = useParams();
  const dispatch = useDispatch();
  const [userRole, setUserRole] = useState("");
  const user = useSelector((state) => state?.user?.user);
  const businessData = useSelector((state) => state.bussiness.business);
  const business = Array.isArray(businessData)
    ? businessData.find((b) => b.bussinessUuid === bussinessUuid)
    : businessData;
  const settings = useSelector((state) => state.bussiness.settings);
  const [employee, setEmployee] = useState(null);
  const [unreadCount, setUnreadCount] = useState(0);
  // const [socket, setSocket] = useState(null);
  const [activeTab, setActiveTab] = useState("notifications");
  const [runTour, setRunTour] = useState(false);
  const [isPaymentPopupOpen, setIsPaymentPopupOpen] = useState(false);
  const [isBusinessQrPopupOpen, setIsBusinessQrPopupOpen] = useState(false);
  const selectedMenu = useSelector((state) => state?.utility?.selectedMenu);
  const steps = [
    {
      target: ".language-tour",
      content: "Change the app language from here.",
      disableBeacon: true,
    },
    {
      target: ".theme-tour",
      content: "Toggle between light and dark mode.",
      disableBeacon: true,
    },
    {
      target: ".calculator-tour",
      content: "Use this calculator for quick calculations during billing.",
      disableBeacon: true,
    },
    {
      target: ".notification-tour",
      content: "View your latest notifications here.",
      disableBeacon: true,
    },
    {
      target: ".cart-tour",
      content: "Quickly create a new sale from here.",
      disableBeacon: true,
    },

    {
      target: ".profile-tour",
      content: "Click here to access your profile settings and logout options.",
      disableBeacon: true,
    },
  ];
  useEffect(() => {
    const hasSeenTour = localStorage.getItem("hasSeenTour");

    const waitForElements = () => {
      if (
        !hasSeenTour &&
        document.querySelector(".calculator-tour") &&
        document.querySelector(".profile-tour") &&
        document.querySelector(".language-tour") &&
        document.querySelector(".theme-tour") &&
        document.querySelector(".notification-tour") &&
        document.querySelector(".cart-tour")
      ) {
        setRunTour(true);
        localStorage.setItem("hasSeenTour", "true");
      } else {
        setTimeout(waitForElements); // retry after 300ms
      }
    };

    waitForElements();
  }, []);

  // useEffect(() => {
  //   const hasSeenTour = localStorage.getItem("hasSeenTour");

  //   const waitForElements = () => {
  //     if (
  //       !hasSeenTour &&
  //       document.querySelector(".calculator-tour") &&
  //       document.querySelector(".profile-tour")
  //     ) {
  //       setRunTour(true);
  //       localStorage.setItem("hasSeenTour", "true");
  //     } else {
  //       setTimeout(waitForElements, 300); // retry after 300ms
  //     }
  //   };

  //   waitForElements();
  // }, []);

  // useEffect(() => {
  //   const hasSeenTour = localStorage.getItem("hasSeenTour");
  //   if (!hasSeenTour) {
  //     setRunTour(true);
  //     localStorage.setItem("hasSeenTour", "true");
  //   }
  // }, []);
  const handleSignout = async () => {
    await localStorage.clear();

    navigate("/");
    window.history.pushState(null, "", window.location.href);
    window.addEventListener("popstate", () => {
      window.history.pushState(null, "", window.location.href);
    });
  };
  const getUserRoleFromLocalStorage = () => {
    const storedRole = localStorage.getItem("role") || "";
    setUserRole(storedRole);
  };
  const [notifications, setNotifications] = useState([]);
  const [isCalculatorOpen, setIsCalculatorOpen] = useState(false);
  useEffect(() => {
    getUserRoleFromLocalStorage();
    const employeeID = localStorage.getItem("employeeID");

    if (userRole === "owner_admin" || userRole === "reseller") {
      getUserData();
      // Fetch business data for reseller role
      if (bussinessUuid) {
        dispatch(getBussinessData(bussinessUuid));
      }
    } else if (employeeID) {
      getEmployeeData();
    }
    getNotificationData();

    // getEmployeeData();
  }, [userRole, bussinessUuid]);

  const getUserData = async () => {
    const userUuid = await localStorage.getItem("userUuid");
    const result = await getUser(userUuid);
    if (result?.status === 404) {
      navigate("/");
      dispatch(setUser({}));
      localStorage.clear();
    } else if (result && result.status == 200) {
      localStorage.setItem("token", result.headers.get("x-auth-token"));
      dispatch(setUser(result.data));
    }
  };
  const getEmployeeData = async () => {
    const employeeID = await localStorage.getItem("employeeID");
    const result = await getOneEmployee(bussinessUuid, employeeID);
    setEmployee(result.data);
  };
  // In your Header component or notification service
  useEffect(() => {
    const fetchDataAndConnect = async () => {
      // First get initial notifications
      await getNotificationData();

      // Then connect to socket
      if (!bussinessUuid) return;

      const newSocket = io(`${CHAT_URL}/notifications`, {
        path: "/socket.io",
        query: { businessId: bussinessUuid },
        transports: ["websocket"],
        withCredentials: true,
      });

      // setSocket(newSocket);

      newSocket.on("connect", () => {
        newSocket.emit("join_business", bussinessUuid);
      });

      newSocket.on("new_notification", (newNotification) => {
        setNotifications((prev) => {
          // Check if notification already exists
          if (!prev.some((n) => n._id === newNotification._id)) {
            return [newNotification, ...prev];
          }
          return prev;
        });

        // Update unread count if notification is unread
        if (!newNotification.isRead) {
          setUnreadCount((prev) => prev + 1);
        }
      });

      return () => {
        newSocket.disconnect();
      };
    };

    fetchDataAndConnect();
  }, [dispatch, bussinessUuid]);

  // Modified getNotificationData
  const getNotificationData = useCallback(async () => {
    try {
      const result = await getNotifications(bussinessUuid);

      if (result) {
        setNotifications(result);
        setUnreadCount(result.filter((n) => !n.isRead).length);
      }
    } catch (error) {
      console.error("Error fetching notifications:", error);
    }
  }, [dispatch, bussinessUuid]);

  const handleNotificationsViewed = (count = 0) => {
    const newUnreadCount = count > 0 ? Math.max(0, unreadCount - count) : 0;
    setUnreadCount(newUnreadCount);
    if (count === 0) {
      markAllNotificationsAsRead(bussinessUuid).catch((error) => {
        setUnreadCount(notifications.filter((n) => !n.isRead).length);
      });
    }
  };

  const toggleCalculatorPopup = () => {
    setIsCalculatorOpen(!isCalculatorOpen);
  };

  const handleSetupPasskey = async () => {
    try {
      if (!user?.email) {
        toast.error(t("PASSKEY.EMAIL_REQUIRED"));
        return;
      }

      const {
        data: { options, challengeKey },
      } = await passkeyService.generateRegistrationOptions({
        email: user.email,
      });

      // Diagnostic: ensure WebAuthn / Web Crypto APIs are available
      console.log("WebAuthn availability:", {
        PublicKeyCredential: typeof window.PublicKeyCredential !== "undefined",
        navigatorCredentials: typeof navigator.credentials !== "undefined",
        crypto: typeof window.crypto !== "undefined",
        subtle: !!(window.crypto && window.crypto.subtle),
      });

      if (
        typeof window.PublicKeyCredential === "undefined" ||
        typeof navigator.credentials === "undefined" ||
        typeof window.crypto === "undefined" ||
        !(window.crypto && window.crypto.subtle)
      ) {
        console.error("Crypto/WebAuthn APIs missing in this environment.");
        toast.error(t("PASSKEY.SETUP_FAILED"));
        return;
      }

      const response = await startRegistration(options);

      const verificationResp = await passkeyService.verifyRegistration({
        email: user.email,
        response,
        challengeKey,
      });

      if (verificationResp.data?.success) {
        toast.success(t("PASSKEY.REGISTERED_SUCCESS"));
      } else {
        toast.error(t("PASSKEY.VERIFICATION_FAILED"));
      }
    } catch (error) {
      console.error("Passkey setup error:", error);
      const errorMsg =
        error?.response?.data?.error ||
        error?.message ||
        t("PASSKEY.SETUP_FAILED");
      toast.error(errorMsg);
    }
  };
  return (
    <>
      <Joyride
        steps={steps}
        run={runTour}
        continuous
        scrollToFirstStep
        showProgress
        showSkipButton
        disableOverlayClose={true}
        styles={{
          options: {
            primaryColor: "#4F46E5",
            textColor: "#1F2937",
            backgroundColor: "#FFFFFF",
            overlayColor: "rgba(0, 0, 0, 0.5)",
            spotlightPadding: 4, // Reduced from 8 to 4
            zIndex: 10000,
            arrowColor: "#FFFFFF",
          },
          tooltipContainer: {
            textAlign: "left",
          },
          tooltip: {
            borderRadius: "12px",
            padding: "20px 24px",
            boxShadow: "0 10px 25px -5px rgba(0, 0, 0, 0.2)",
            border: "none",
            maxWidth: "400px",
          },
          tooltipTitle: {
            fontSize: "1.2rem",
            fontWeight: "600",
            color: "#2218a7ff",
            marginBottom: "8px",
          },
          tooltipContent: {
            fontSize: "0.95rem",
            lineHeight: "1.5",
            padding: "0px",
            marginBottom: "12px",
            color: "#4B5563",
          },
          footer: {
            marginTop: "12px",
            justifyContent: "flex-end",
          },
          buttonClose: {
            display: "none",
          },
          buttonNext: {
            backgroundColor: "#4F46E5",
            color: "#fff",
            borderRadius: "8px",
            padding: "8px 16px",
            fontWeight: "500",
            boxShadow: "0 1px 3px rgba(0, 0, 0, 0.1)",
            transition: "all 0.2s ease",
            ":hover": {
              backgroundColor: "#4338CA",
              transform: "translateY(-1px)",
              boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
            },
          },
          buttonBack: {
            color: "#2e21c0ff",
            marginRight: "16px",
            fontWeight: "500",
            borderRadius: "16px",
            padding: "10px 20px",
            background: "rgba(255, 255, 255, 0.6)",
            border: "1px solid rgba(147, 197, 253, 0.4)",
            transition: "all 0.3s ease",
            ":hover": {
              color: "#1D4ED8",
              background: "rgba(255, 255, 255, 0.8)",
              transform: "translateY(-2px)",
            },
          },
          buttonSkip: {
            color: "#475aeaff",
            marginRight: "auto",
            fontWeight: "500",
            textShadow: "1px 1px 2px rgba(255,255,255,0.8)",
            ":hover": {
              color: "#3B82F6",
              textDecoration: "underline",
            },
          },
          beacon: {
            inner: {
              backgroundColor: "#4F46E5",
            },
            outer: {
              backgroundColor: "rgba(79, 70, 229, 0.3)",
              border: "2px solid #4F46E5",
            },
          },
          spotlight: {
            borderRadius: "6px",
            boxShadow: "0 0 0 9999px rgba(0, 0, 0, 0.5)",
            margin: 2, // Added slight margin for better visibility
          },
        }}
        locale={{
          back: "← Back",
          close: "× Close",
          last: "☁ Finish",
          next: "Next →",
          skip: "Skip Tour",
        }}
      />
      <div className='h-14 px-4 z-50 flex items-center border-b border-gray-200 justify-between dark:bg-[#170f2a] dark:border-[#170f2a]'>
        {" "}
        {/* <div> */}
        {/* </div> */}
        <div className='relative'>
          {selectedMenu === "dashboard" ? (
            <div className='flex items-center'>
              <span>
                <UserImage avatar={business?.businesslogo} />
              </span>
              <span className='flex flex-wrap items-center ml-3'>
                <h1 className='text-xl font-semibold dark:text-white'>
                  {t("COMMON.WELCOME")}
                </h1>

                <h2 className='text-lg dark:text-white ml-2'>
                  {business?.businessName}
                </h2>
                {user && (
                  <span className='flex flex-wrap items-center ml-4 mt-2 sm:mt-0'>
                    <div className='bg-green-50 dark:bg-green-800 rounded-lg px-3 py-1 inline-flex items-center space-x-2 border border-green-200 dark:border-green-700'>
                      <HiOutlineUser className='h-4 w-4 text-green-600 dark:text-green-300' />
                      <span className='font-medium text-sm text-green-700 dark:text-green-100'>
                        {user?.firstName || employee?.employeeName}
                      </span>
                    </div>
                    <p className='ml-1 text-gray-600 dark:text-gray-200 text-xs'>
                      {/* ( {userRole}) */}({" "}
                      {userRole
                        .split("_")
                        .map(
                          (word) =>
                            word.charAt(0).toUpperCase() + word.slice(1),
                        )
                        .join(" ")}{" "}
                      )
                    </p>
                  </span>
                )}
              </span>
            </div>
          ) : (
            <span className='text-2xl dark:text-white'>{selectedMenu}</span>
          )}
        </div>
        <div className='flex items-center gap-2 mr-2'>
          <div className='language-tour'>
            <LanguageChenger displayType='dropdown' />
          </div>

          {/* <button
            onClick={toggleTheme}
            // className='p-2 rounded-md bg-gray-200 dark:bg-gray-800'
          >
            {theme === "light" ? (
              <MdDarkMode size={24} className='text-gray-900' />
            ) : (
              <MdLightMode size={24} className='text-yellow-400' />
            )}
          </button> */}
          <div className='theme-tour'>
            <ThemeBtn />
          </div>

          {settings?.appSettings?.showHeaderCalculator === true && (
            <div className='cursor-pointer calculator-tour'>
              <div className='calculator-icon ' onClick={toggleCalculatorPopup}>
                <TiCalculator size={30} className='text-green-500' />
              </div>
            </div>
          )}

          {isCalculatorOpen && (
            <div className='absolute right-32 top-auto transform translate-y-60 w-100 bg-white dark:bg-gray-700 z-10'>
              <Calculator />
            </div>
          )}

          <Popover className='relative'>
            {({ open }) => (
              <>
                {/* <Popover.Button
                  className={classNames(
                    open && "bg-gray-100 dark:bg-gray-700",
                    "group inline-flex items-center rounded-sm p-1.5 text-gray-700 hover:text-opacity-100 focus:outline-none active:bg-gray-100 dark:text-white dark:hover:bg-gray-600",
                    "notification-tour"
                  )}
                >
                  <HiOutlineBell fontSize={24} />
                </Popover.Button> */}

                <Popover.Button
                  onClick={() => {
                    // When notification icon is clicked, mark all as viewed
                    if (unreadCount > 0) {
                      handleNotificationsViewed();
                    }
                  }}
                  className={classNames(
                    open && "bg-gray-100 dark:bg-gray-700",
                    "group inline-flex items-center rounded-sm p-1.5 text-gray-700 hover:text-opacity-100 focus:outline-none active:bg-gray-100 dark:text-white dark:hover:bg-gray-600",
                    "notification-tour relative",
                  )}
                >
                  {/* <HiOutlineBell fontSize={24} />
                  {unreadCount > 0 && (
                    <span className='absolute -top-1 -right-1 bg-red-500 text-white text-xs font-bold rounded-full h-5 w-5 flex items-center justify-center'>
                      {unreadCount}
                    </span>
                  )} */}

                  <HiOutlineBell fontSize={24} />
                  {unreadCount > 0 && (
                    <span className='absolute -top-1 -right-1 bg-red-500 text-white text-xs font-bold rounded-full h-5 w-5 flex items-center justify-center'>
                      {unreadCount > 9 ? "9+" : unreadCount}
                    </span>
                  )}
                </Popover.Button>
                <Transition
                  as={Fragment}
                  enter='transition ease-out duration-200'
                  enterFrom='opacity-0 translate-y-1'
                  enterTo='opacity-100 translate-y-0'
                  leave='transition ease-in duration-150'
                  leaveFrom='opacity-100 translate-y-0'
                  leaveTo='opacity-0 translate-y-1'
                >
                  <Popover.Panel className='absolute right-0 z-100 mt-2.5 transform w-96'>
                    <div className='bg-white rounded-sm shadow-md ring-1 ring-black ring-opacity-5 px-4 py-3 dark:bg-gray-800 dark:text-white'>
                      {/* Tabs for switching between notifications and new features */}
                      <div className='flex border-b border-gray-200 dark:border-gray-700'>
                        <button
                          className={`px-4 py-2 font-medium text-sm ${
                            activeTab === "notifications"
                              ? "text-blue-600 border-b-2 border-blue-600 dark:text-blue-400 dark:border-blue-400"
                              : "text-gray-500 hover:text-gray-700 dark:text-gray-400 dark:hover:text-gray-300"
                          }`}
                          onClick={() => setActiveTab("notifications")}
                        >
                          {t("COMMON.NOTIFICATIONS")}
                        </button>
                        <button
                          className={`px-4 py-2 font-medium text-sm ${
                            activeTab === "features"
                              ? "text-blue-600 border-b-2 border-blue-600 dark:text-blue-400 dark:border-blue-400"
                              : "text-gray-500 hover:text-gray-700 dark:text-gray-400 dark:hover:text-gray-300"
                          }`}
                          onClick={() => setActiveTab("features")}
                        >
                          {t("COMMON.ANNOUNCEMENT")}
                        </button>
                      </div>

                      {/* Content based on active tab */}
                      <div
                        className='mt-2 py-1'
                        style={{ maxHeight: "80vh", overflowY: "auto" }}
                      >
                        {activeTab === "notifications" ? (
                          <>
                            <strong className='text-gray-700 font-medium dark:text-white'>
                              {t("COMMON.NOTIFICATIONS")}
                            </strong>
                            <div className='mt-2 py-1 scroll-w-6 pr-2'>
                              <Notification
                                notifications={notifications}
                                onNotificationsViewed={
                                  handleNotificationsViewed
                                }
                              />
                            </div>
                          </>
                        ) : (
                          <div className='p-2'>
                            <h3 className='font-medium text-gray-800 dark:text-gray-200 mb-2'>
                              Latest Updates
                            </h3>
                            {/* Render your new features content here */}
                            <div className='space-y-3'>
                              <div className='p-2 rounded bg-gray-50 dark:bg-gray-700'>
                                <p className='font-medium'>New Dashboard</p>
                                <p className='text-sm text-gray-600 dark:text-gray-300'>
                                  Check out our redesigned dashboard with
                                  improved analytics.
                                </p>
                              </div>
                              <div className='p-2 rounded bg-gray-50 dark:bg-gray-700'>
                                <p className='font-medium'>Dark Mode</p>
                                <p className='text-sm text-gray-600 dark:text-gray-300'>
                                  We've added dark mode support for better
                                  night-time usage.
                                </p>
                              </div>
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                  </Popover.Panel>
                </Transition>
              </>
            )}
          </Popover>
          {settings?.appSettings?.quickCartShortcut === true && (
            <button className='cursor-pointer cart-tour' title='New Sale'>
              <BsCart4
                size={22}
                onClick={() =>
                  navigate(`/${bussinessUuid}/dashboard/bills/sale`, {
                    state: { isOpen: true },
                  })
                }
                className='text-gray-600 dark:text-white'
              />
            </button>
          )}

          <Menu as='div' className='relative profile-tour'>
            <div>
              <Menu.Button className='ml-2 bg-gray-800 flex text-sm rounded-full focus:outline-none focus:ring-2 focus:ring-neutral-400'>
                <span className='sr-only'>Open user menu</span>
                {/* profilePicture */}
                <div
                  className='h-10 w-10 rounded-full bg-sky-500 bg-cover bg-no-repeat bg-center'
                  style={{
                    backgroundImage: user.profilePicture
                      ? "url(" + AWS_URL + user?.profilePicture + ")"
                      : 'url("https://cdn.pixabay.com/photo/2015/10/05/22/37/blank-profile-picture-973460_1280.png")',
                  }}
                >
                  <span className='sr-only'>Marc Backes</span>
                </div>
              </Menu.Button>
            </div>
            <Transition
              as={Fragment}
              enter='transition ease-out duration-100'
              enterFrom='transform opacity-0 scale-95'
              enterTo='transform opacity-100 scale-100'
              leave='transition ease-in duration-75'
              leaveFrom='transform opacity-100 scale-100'
              leaveTo='transform opacity-0 scale-95'
            >
              <Menu.Items className='origin-top-right z-50 absolute right-0 mt-2 w-64 rounded-md shadow-xl p-2 bg-white border border-gray-200 dark:border-gray-700 ring-1 ring-black ring-opacity-5 focus:outline-none dark:bg-gray-800 dark:ring-gray-600'>
                <div className='px-4 py-3 border-b border-gray-100 dark:border-gray-700'>
                  <p className='text-sm font-medium text-gray-900 dark:text-white'>
                    {user?.phone || employee?.phoneNumber}
                  </p>
                  <p className='ml-1 text-gray-600 dark:text-gray-200 text-xs'>
                    {/* ({userRole}) */}({" "}
                    {userRole
                      .split("_")
                      .map(
                        (word) => word.charAt(0).toUpperCase() + word.slice(1),
                      )
                      .join(" ")}{" "}
                    )
                  </p>
                </div>

                {/* Menu items */}
                <div className='py-1'>
                  <Menu.Item>
                    {({ active }) => (
                      <div
                        onClick={() =>
                          navigate(`/${bussinessUuid}/dashboard/profile`)
                        }
                        className={classNames(
                          active
                            ? "bg-blue-50 text-blue-900 dark:bg-gray-700 dark:text-blue-300"
                            : "text-gray-700 dark:text-gray-200",
                          "group flex items-center px-4 py-2 text-sm rounded-md cursor-pointer transition-colors",
                        )}
                      >
                        <UserIcon className='w-5 h-5 mr-3 text-gray-400 group-hover:text-blue-500 dark:group-hover:text-blue-300' />
                        {t("COMMON.YOUR_PROFILE")}
                      </div>
                    )}
                  </Menu.Item>

                  <Menu.Item>
                    {({ active }) => (
                      <div
                        onClick={handleSetupPasskey}
                        className={classNames(
                          active
                            ? "bg-blue-50 text-blue-900 dark:bg-gray-700 dark:text-blue-300"
                            : "text-gray-700 dark:text-gray-200",
                          "group flex items-center px-4 py-2 text-sm rounded-md cursor-pointer transition-colors",
                        )}
                      >
                        <MdFingerprint className='w-5 h-5 mr-3 text-gray-400 group-hover:text-blue-500 dark:group-hover:text-blue-300' />
                        {t("PASSKEY.SETUP_MENU")}
                      </div>
                    )}
                  </Menu.Item>

                  {/* <Menu.Item>
                    {({ active }) => (
                      <div
                        onClick={() => {
                          if (userRole === "owner_admin")
                            setIsPaymentPopupOpen(true);
                        }}
                        className={classNames(
                          active
                            ? "bg-blue-50 text-blue-900 dark:bg-gray-700 dark:text-blue-300"
                            : "text-gray-700 dark:text-gray-200",
                          "group flex items-center px-4 py-2 text-sm rounded-md cursor-pointer transition-colors",
                          userRole !== "owner_admin"
                            ? "opacity-50 cursor-not-allowed"
                            : "",
                        )}
                        aria-disabled={userRole !== "owner_admin"}
                      >
                        <PlusCircleIcon className='w-5 h-5 mr-3 text-gray-400 group-hover:text-blue-500 dark:group-hover:text-blue-300' />
                        {t("COMMON.PAYMENT_GATEWAY")}
                      </div>
                    )}
                  </Menu.Item> */}
                  <Menu.Item>
                    {({ active }) => (
                      <div
                        onClick={() => {
                          if (userRole === "owner_admin") {
                            setIsBusinessQrPopupOpen(true);
                          }
                        }}
                        className={classNames(
                          active
                            ? "bg-blue-50 text-blue-900 dark:bg-gray-700 dark:text-blue-300"
                            : "text-gray-700 dark:text-gray-200",
                          "group flex items-center px-4 py-2 text-sm rounded-md cursor-pointer transition-colors",
                          userRole !== "owner_admin"
                            ? "opacity-50 cursor-not-allowed"
                            : "",
                        )}
                        aria-disabled={userRole !== "owner_admin"}
                      >
                        <GridIcon className='w-5 h-5 mr-3 text-gray-400 group-hover:text-blue-500 dark:group-hover:text-blue-300' />
                        Business Details QR
                      </div>
                    )}
                  </Menu.Item>
                  {/* <Menu.Item>
                    {({ active }) => (
                      <div
                        onClick={() =>
                          navigate(`/${bussinessUuid}/dashboard/ecommmerce`)
                        }
                        className={classNames(
                          active
                            ? "bg-blue-50 text-blue-900 dark:bg-gray-700 dark:text-blue-300"
                            : "text-gray-700 dark:text-gray-200",
                          "group flex items-center px-4 py-2 text-sm rounded-md cursor-pointer transition-colors",
                        )}
                      >
                        <IoSettingsOutline className='w-5 h-5 mr-3 text-gray-400 group-hover:text-blue-500 dark:group-hover:text-blue-300' />
                        {t("COMMON.ECOMMERCE")}
                      </div>
                    )}
                  </Menu.Item> */}
                  {/* Settings option */}
                  <Menu.Item>
                    {({ active }) => (
                      <div
                        onClick={() =>
                          navigate(`/${bussinessUuid}/dashboard/settingPage`)
                        }
                        className={classNames(
                          active
                            ? "bg-blue-50 text-blue-900 dark:bg-gray-700 dark:text-blue-300"
                            : "text-gray-700 dark:text-gray-200",
                          "group flex items-center px-4 py-2 text-sm rounded-md cursor-pointer transition-colors",
                        )}
                      >
                        <IoSettingsOutline className='w-5 h-5 mr-3 text-gray-400 group-hover:text-blue-500 dark:group-hover:text-blue-300' />
                        {t("COMMON.SETTINGS")}
                      </div>
                    )}
                  </Menu.Item>
                   {/* <Menu.Item>
                    {({ active }) => (
                      <div
                        onClick={() =>
                          navigate(`/${bussinessUuid}/dashboard/send-reminders`)
                        }
                        className={classNames(
                          active
                            ? "bg-blue-50 text-blue-900 dark:bg-gray-700 dark:text-blue-300"
                            : "text-gray-700 dark:text-gray-200",
                          "group flex items-center px-4 py-2 text-sm rounded-md cursor-pointer transition-colors",
                        )}
                      >
                        <IoSettingsOutline className='w-5 h-5 mr-3 text-gray-400 group-hover:text-blue-500 dark:group-hover:text-blue-300' />
                        Payment Reminder Settings
                      </div>
                    )}
                  </Menu.Item>  */}
                  <Menu.Item>
                    {({ active }) => (
                      <div
                        onClick={() =>
                          navigate(`/${bussinessUuid}/dashboard/subscriber`)
                        }
                        className={classNames(
                          active
                            ? "bg-blue-50 text-blue-900 dark:bg-gray-700 dark:text-blue-300"
                            : "text-gray-700 dark:text-gray-200",
                          "group flex items-center px-4 py-2 text-sm rounded-md cursor-pointer transition-colors",
                        )}
                      >
                        <MdOutlineSubscriptions className='w-5 h-5 mr-3 text-gray-400 group-hover:text-blue-500 dark:group-hover:text-blue-300' />
                        {t("COMMON.SUBSCRIBER")}{" "}
                      </div>
                    )}
                  </Menu.Item>
                  <Menu.Item>
                    {({ active }) => (
                      <div
                        onClick={handleSignout}
                        className={classNames(
                          active
                            ? "bg-red-50 text-red-900 dark:bg-gray-700 dark:text-red-400"
                            : "text-red-600 dark:text-red-400",
                          "group flex items-center px-4 py-2 text-sm rounded-md cursor-pointer transition-colors",
                        )}
                      >
                        <LogoutIcon className='w-5 h-5 mr-3 text-red-400 group-hover:text-red-600 dark:group-hover:text-red-500' />
                        {t("COMMON.SIGN_OUT")}
                      </div>
                    )}
                  </Menu.Item>
                </div>
              </Menu.Items>
            </Transition>
          </Menu>
        </div>
      </div>
      <PaymentGatewayPopup
        businessUuid={bussinessUuid}
        businessName={business?.businessName}
        isOpen={isPaymentPopupOpen}
        onClose={() => setIsPaymentPopupOpen(false)}
        onSuccess={() => {
          console.log("Payment gateway verified!");
          // Optional: reload data or show toast
        }}
      />
      <BusinessDetailsQrPopup
        isOpen={isBusinessQrPopupOpen}
        onClose={() => setIsBusinessQrPopupOpen(false)}
        business={business}
        bussinessUuid={bussinessUuid}
        settings={settings}
      />
    </>
  );
}
